export default __webpack_public_path__ + "images/62f7cf7b3716fecc2c24cf14292bbca2.svg";